var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manage-campaign col-md-12" },
    [
      _c("h2", [_vm._v("Manage Campaign")]),
      _c("br"),
      _vm._m(0),
      _c("div", { staticClass: "tab-content" }, [
        _c(
          "div",
          {
            staticClass: "tab-pane fade in active",
            attrs: { id: "awaiting-approval-campaigns" }
          },
          [
            _c("br"),
            _vm.awaitingApprovalCampaigns.length
              ? _c(
                  "table",
                  [
                    _vm._m(1),
                    _vm._l(_vm.awaitingApprovalCampaigns, function(camp) {
                      return _c("tr", { key: camp.id }, [
                        _c("td", [
                          _c("h5", [_vm._v(_vm._s(camp.campaign_name))]),
                          _c("ul", [
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/sadmin/" + camp.id + "/quick-review"
                                    }
                                  },
                                  [_vm._v("Quick Review")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/sadmin/" +
                                        camp.id +
                                        "/advanced-review"
                                    }
                                  },
                                  [_vm._v("Advanced Review")]
                                )
                              ],
                              1
                            ),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    "data-toggle": "modal",
                                    "data-target": "#exampleModal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setCampValue(camp.id)
                                    }
                                  }
                                },
                                [_vm._v("Add notes")]
                              )
                            ]),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    "data-toggle": "modal",
                                    "data-target": "#delete-campaign-popup"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setCampaignToDelete(camp.id)
                                    }
                                  }
                                },
                                [_vm._v("Delete Campaign")]
                              )
                            ])
                          ])
                        ]),
                        _vm._m(2, true),
                        camp.geo_location_type == "any-user-location"
                          ? _c("td", [_vm._v("Anywhere")])
                          : _vm._e(),
                        camp.geo_location_type == "any-physical-location"
                          ? _c("td", [_vm._v("Custom Location")])
                          : _vm._e(),
                        _c("td", [_vm._v("Free")]),
                        _c("td", [
                          _vm._v("Company: " + _vm._s(camp.name)),
                          _c("br"),
                          _vm._v(
                            "\n                Email: " + _vm._s(camp.email)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                User Name: " +
                              _vm._s(camp.contact_person_name)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Mobile: " +
                              _vm._s(camp.contact_person_mobile_number)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Date: " +
                              _vm._s(
                                _vm._f("humanReadableDate")(camp.updated_at)
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _c("h3", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("No Pending Campaign For Approval")
                ]),
            _c(
              "div",
              {
                staticClass: "modal fade note_popup",
                attrs: {
                  id: "exampleModal",
                  tabindex: "-1",
                  role: "dialog",
                  "aria-labelledby": "exampleModalLabel",
                  "aria-hidden": "true"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog", attrs: { role: "document" } },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _vm._m(3),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("h5", [_vm._v("Leave a note for company")]),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.note,
                              expression: "note"
                            }
                          ],
                          attrs: {
                            placeholder: "Type your notes here",
                            name: "note"
                          },
                          domProps: { value: _vm.note },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.note = $event.target.value
                            }
                          }
                        })
                      ]),
                      _c("div", { staticClass: "center" }, [
                        _c(
                          "button",
                          {
                            ref: "exitModel",
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button", "data-dismiss": "modal" }
                          },
                          [_vm._v("Exit")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.sendCampaignNote()
                              }
                            }
                          },
                          [_vm._v("Send")]
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            attrs: { id: "need-more-information-campaigns" }
          },
          [
            _c("br"),
            _vm.needMoreInfo.length
              ? _c(
                  "table",
                  [
                    _vm._m(4),
                    _vm._l(_vm.needMoreInfo, function(camp) {
                      return _c("tr", { key: camp.id }, [
                        _c("td", [
                          _c("h5", [_vm._v(_vm._s(camp.campaign_name))]),
                          _c("ul", [
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/sadmin/" + camp.id + "/quick-review"
                                    }
                                  },
                                  [_vm._v("Quick Review")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/sadmin/" +
                                        camp.id +
                                        "/advanced-review"
                                    }
                                  },
                                  [_vm._v("Advanced Review")]
                                )
                              ],
                              1
                            ),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    "data-toggle": "modal",
                                    "data-target": "#exampleModal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setCampValue(camp.id)
                                    }
                                  }
                                },
                                [_vm._v("Add notes")]
                              )
                            ]),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    "data-toggle": "modal",
                                    "data-target": "#delete-campaign-popup"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setCampaignToDelete(camp.id)
                                    }
                                  }
                                },
                                [_vm._v("Delete Campaign")]
                              )
                            ])
                          ])
                        ]),
                        _vm._m(5, true),
                        camp.geo_location_type == "any-user-location"
                          ? _c("td", [_vm._v("Anywhere")])
                          : _vm._e(),
                        camp.geo_location_type == "any-physical-location"
                          ? _c("td", [_vm._v("Custom Location")])
                          : _vm._e(),
                        _c("td", [_vm._v("Free")]),
                        _c("td", [
                          _vm._v("Company: " + _vm._s(camp.name)),
                          _c("br"),
                          _vm._v(
                            "\n                Email: " + _vm._s(camp.email)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                User Name: " +
                              _vm._s(camp.contact_person_name)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Mobile: " +
                              _vm._s(camp.contact_person_mobile_number)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Date: " +
                              _vm._s(
                                _vm._f("humanReadableDate")(camp.updated_at)
                              )
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _c("h3", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("No Need More Information Campaigns For Now")
                ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            attrs: { id: "incomplete-campaigns" }
          },
          [
            _c("br"),
            _vm.incompletes.length
              ? _c(
                  "table",
                  [
                    _vm._m(6),
                    _vm._l(_vm.incompletes, function(camp) {
                      return _c("tr", { key: camp.id }, [
                        _c("td", [
                          _c("h5", [_vm._v(_vm._s(camp.campaign_name))]),
                          _c(
                            "h6",
                            {
                              staticStyle: {
                                "font-size": "15px",
                                "font-weight": "400"
                              }
                            },
                            [
                              _vm._v(
                                "Drop out: " +
                                  _vm._s(_vm.getDropOutReason(camp))
                              )
                            ]
                          ),
                          _c(
                            "ul",
                            {
                              staticStyle: {
                                padding: "0px !important",
                                border: "0px"
                              }
                            },
                            [
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      background: "#f00",
                                      color: "#fff",
                                      padding: "3px 8px",
                                      "border-radius": "8px"
                                    },
                                    attrs: {
                                      href: "#",
                                      "data-toggle": "modal",
                                      "data-target": "#delete-campaign-popup"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setCampaignToDelete(camp.id)
                                      }
                                    }
                                  },
                                  [_vm._v("Delete")]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._m(7, true),
                        camp.geo_location_type == "any-user-location"
                          ? _c("td", [_vm._v("Anywhere")])
                          : _vm._e(),
                        camp.geo_location_type == "any-physical-location"
                          ? _c("td", [_vm._v("Custom Location")])
                          : _vm._e(),
                        _c("td", [_vm._v("Free")]),
                        _c("td", [
                          _vm._v("Company: " + _vm._s(camp.name)),
                          _c("br"),
                          _vm._v(
                            "\n                Email: " + _vm._s(camp.email)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                User Name: " +
                              _vm._s(camp.contact_person_name)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Mobile: " +
                              _vm._s(camp.contact_person_mobile_number)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Date: " +
                              _vm._s(
                                _vm._f("humanReadableDate")(camp.updated_at)
                              )
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _c("h3", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("No Incomplete Campaigns For Now")
                ])
          ]
        ),
        _c(
          "div",
          { staticClass: "tab-pane fade", attrs: { id: "launched-campaigns" } },
          [
            _c("br"),
            _vm.launchedCampaigns.length
              ? _c(
                  "table",
                  [
                    _vm._m(8),
                    _vm._l(_vm.launchedCampaigns, function(camp) {
                      return _c("tr", { key: camp.id }, [
                        _c("td", [
                          _c("h5", [_vm._v(_vm._s(camp.campaign_name))]),
                          _c("ul", [
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/sadmin/" + camp.id + "/quick-review"
                                    }
                                  },
                                  [_vm._v("Quick Review")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/sadmin/" +
                                        camp.id +
                                        "/advanced-review"
                                    }
                                  },
                                  [_vm._v("Advanced Review")]
                                )
                              ],
                              1
                            ),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    "data-toggle": "modal",
                                    "data-target": "#exampleModal"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setCampValue(camp.id)
                                    }
                                  }
                                },
                                [_vm._v("Add notes")]
                              )
                            ]),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "#",
                                    "data-toggle": "modal",
                                    "data-target": "#delete-campaign-popup"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setCampaignToDelete(camp.id)
                                    }
                                  }
                                },
                                [_vm._v("Delete Campaign")]
                              )
                            ])
                          ])
                        ]),
                        _vm._m(9, true),
                        camp.geo_location_type == "any-user-location"
                          ? _c("td", [_vm._v("Anywhere")])
                          : _vm._e(),
                        camp.geo_location_type == "any-physical-location"
                          ? _c("td", [_vm._v("Custom Location")])
                          : _vm._e(),
                        _c("td", [_vm._v("Free")]),
                        _c("td", [
                          _vm._v("Company: " + _vm._s(camp.name)),
                          _c("br"),
                          _vm._v(
                            "\n                Email: " + _vm._s(camp.email)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                User Name: " +
                              _vm._s(camp.contact_person_name)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Mobile: " +
                              _vm._s(camp.contact_person_mobile_number)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                Date: " +
                              _vm._s(
                                _vm._f("humanReadableDate")(camp.updated_at)
                              )
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _c("h3", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("No Launched Campaigns For Now")
                ])
          ]
        )
      ]),
      _c("DeleteCampaignPopup", {
        attrs: {
          popupId: "delete-campaign-popup",
          campaignId: _vm.campaignToDelete
        },
        on: { campaignDeleted: _vm.onCampaignDeleted }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "nav nav-tabs" }, [
      _c("li", { staticClass: "active" }, [
        _c(
          "a",
          {
            attrs: {
              "data-toggle": "tab",
              href: "#awaiting-approval-campaigns"
            }
          },
          [_vm._v("Awaiting Approval")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { attrs: { "data-toggle": "tab", href: "#launched-campaigns" } },
          [_vm._v("Lauched Campaigns")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              "data-toggle": "tab",
              href: "#need-more-information-campaigns"
            }
          },
          [_vm._v("Need More Information")]
        )
      ]),
      _c("li", [
        _c(
          "a",
          { attrs: { "data-toggle": "tab", href: "#incomplete-campaigns" } },
          [_vm._v("Incomplete Campaigns")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { "border-bottom": "1px solid #000" } }, [
      _c("th", [_vm._v("Name")]),
      _c("th", [_vm._v("Status")]),
      _c("th", [_vm._v("Location Type")]),
      _c("th", [_vm._v("Plan")]),
      _c("th", [_vm._v("Company Details")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "button",
        { staticClass: "awaiting_approval", staticStyle: { border: "0px" } },
        [_vm._v("Awaiting Approval")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", [_vm._v("Add a Note")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { "border-bottom": "1px solid #000" } }, [
      _c("th", [_vm._v("Name")]),
      _c("th", [_vm._v("Status")]),
      _c("th", [_vm._v("Location Type")]),
      _c("th", [_vm._v("Plan")]),
      _c("th", [_vm._v("Company Details")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "button",
        { staticClass: "awaiting_approval", staticStyle: { border: "0px" } },
        [_vm._v("Need more information")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { "border-bottom": "1px solid #000" } }, [
      _c("th", [_vm._v("Name")]),
      _c("th", [_vm._v("Status")]),
      _c("th", [_vm._v("Location Type")]),
      _c("th", [_vm._v("Plan")]),
      _c("th", [_vm._v("Company Details")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "button",
        { staticClass: "awaiting_approval", staticStyle: { border: "0px" } },
        [_vm._v("Incomplete")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { "border-bottom": "1px solid #000" } }, [
      _c("th", [_vm._v("Name")]),
      _c("th", [_vm._v("Status")]),
      _c("th", [_vm._v("Location Type")]),
      _c("th", [_vm._v("Plan")]),
      _c("th", [_vm._v("Company Details")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "button",
        { staticClass: "awaiting_approval", staticStyle: { border: "0px" } },
        [_vm._v("Lauched")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }